import { FC, PropsWithChildren } from "react";

import { Column, BoxProps } from "@hightouch/htui";

import { SIZES } from "./container-utils";

export type ContainerSize = keyof typeof SIZES;

export type Props = {
  size?: string;
  center?: boolean;
} & BoxProps;

export const Container: FC<PropsWithChildren<Props>> = ({
  children,
  center = true,
  size = "large",
  ...props
}) => {
  return (
    <Column
      width="100%"
      mx={center ? "auto" : 0}
      flex={1}
      maxWidth={SIZES[size] ?? size}
      {...props}
    >
      {children}
    </Column>
  );
};
